<template>
  <div>
    <!-- Title -->
    <h3 class="mb-6 text-center text-lg font-medium text-gray-600">
      Pide tu cita en tienda
    </h3>

    <!-- Options -->
    <div class="space-y-3">
      <button
        v-for="store in stores"
        :key="store.id"
        type="button"
        @click="select(store.next, store.nextProps)"
        :class="[
          'w-full rounded-lg border border-solid border-gray-500 bg-white py-3 text-sm text-gray-600 hover:bg-gray-50'
        ]"
      >
        {{ store.label }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue"
export interface StoreItem {
  id: string
  label: string
  next: 'iFrameNexor',
  nextProps: unknown
}

const props = defineProps<{
  stores: StoreItem[]
  modelValue?: string
}>()

const emit = defineEmits<{
  (e: 'next', step, props): void
  (e: 'back'): void
}>()

const selected = computed(() => props.modelValue)

const select = (next: string, props: unknown) => {
  emit('next', next, props)
}
</script>
